// src/hooks/useViewOnly.js
// A shop that sells on its OWN computer (MMM Fashion, synced to the cloud) uses this web app to SEE —
// sales, invoices, reports, stock — not to sell: its sizes / colours, exchanges and credit notes live in
// the Windows app. The cloud marks such an account (tenant.product = 'fashion') when its computer syncs;
// /api/subscription tells us. Every MMM POS shop gets false → nothing changes for them.
import { useQuery } from '@tanstack/react-query';
import api from '../config/api';

export default function useViewOnly() {
  const { data } = useQuery({
    queryKey: ['subscription'],
    queryFn: () => api.get('/api/subscription').then((r) => r.data),
    staleTime: 60 * 1000,
  });
  return !!data && data.product === 'fashion';
}
